import React, { memo } from 'react';

const PolicySection = memo(({ 
  policyEnabled, 
  policyLoading, 
  onToggle 
}) => {
  return (
    <div className="leave-policy-section">
      <div className="policy-header">
        <h4>Leave Policy Settings</h4>
        <p className="policy-description">
          Control leave restrictions for this department
        </p>
      </div>
      
      <div className="policy-toggle">
        <div className="toggle-label">
          <span className="policy-name">Prevent Same Date Leaves</span>
          <span className="policy-help">
            When enabled, prevents multiple employees from taking leave on the same date if they share the same headquarter
          </span>
        </div>
        
        <div className="toggle-control">
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={policyEnabled}
              onChange={onToggle}
              disabled={policyLoading}
            />
            <span className="toggle-slider"></span>
          </label>
          {policyLoading && <span className="loading-text">Updating...</span>}
        </div>
      </div>
    </div>
  );
});

PolicySection.displayName = 'PolicySection';

export default PolicySection; 